import { DummyProps } from './dummy.config';

const Dummy = (props: DummyProps) => {
  return <div style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(props, null, 2)}</div>;
};

export default Dummy;
